import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { LABEL_PRESET_ICON_NAMES, LABEL_PRESET_ICON_URLS } from '../../defaults';
import {
  UploadIconDialogComponent,
  UploadIconDialogResult,
} from '@app/sharedModule/components/upload-icon-dialog/upload-icon-dialog.component';

@Component({
  selector: 'label-component-editor',
  templateUrl: './label-component-editor.component.html',
  styleUrls: ['./label-component-editor.component.scss'],
  standalone: false,
})
export class LabelComponentEditorComponent implements OnInit {
  @Input() componentForm: UntypedFormGroup;

  optionsForm: UntypedFormGroup;
  initialText: string;

  readonly presetIconUrls = LABEL_PRESET_ICON_NAMES.map((name) => LABEL_PRESET_ICON_URLS[name]);

  private destroyRef = inject(DestroyRef);

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this.optionsForm = this.componentForm.get('options') as UntypedFormGroup;
    this.initialText = this.optionsForm.get('text')?.value ?? '';
  }

  get iconUrlValue(): string | File {
    return this.optionsForm?.get('iconUrl')?.value ?? '';
  }

  get customIconUrlValue(): string | File {
    return this.optionsForm?.get('customIconUrl')?.value ?? '';
  }

  onTextChange(html: string): void {
    this.optionsForm.get('text').setValue(html);
    this.optionsForm.markAsDirty();
  }

  onIconUrlChange(value: string | File): void {
    this.optionsForm.get('iconUrl').setValue(value);
    this.optionsForm.markAsDirty();
  }

  onUploadCustomIcon(): void {
    this.dialog
      .open<UploadIconDialogComponent, void, UploadIconDialogResult | null>(UploadIconDialogComponent, {
        width: '576px',
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        if (!result) return;
        this.optionsForm.get('customIconUrl').setValue(result.file);
        this.optionsForm.get('iconUrl').setValue(result.file);
        this.optionsForm.markAsDirty();
      });
  }

  onRemoveCustomIcon(): void {
    const customValue = this.optionsForm.get('customIconUrl')?.value;
    const iconValue = this.optionsForm.get('iconUrl')?.value;
    const wasSelected = !!customValue && iconValue === customValue;
    this.optionsForm.get('customIconUrl').setValue(null);
    if (wasSelected) {
      this.optionsForm.get('iconUrl').setValue('');
    }
    this.optionsForm.markAsDirty();
  }
}
